import { Mail, MapPin, Phone, Shield } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-50 to-gray-100 border-t border-border py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <span className="font-medium text-lg">NY Glass</span>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              NYC Custom Glass & Mirrors
            </p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
              <Shield className="w-4 h-4" />
              <span>Licensed & Insured</span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4">Contact</h4>
            <div className="space-y-3">
              <a
                href="tel:6468999891"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                <Phone className="w-4 h-4" />
                646-899-9891
              </a>
              <a
                href="mailto:info@ny-glass.com"
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                <Mail className="w-4 h-4" />
                info@ny-glass.com
              </a>
            </div>
          </div>

          {/* Service Area */}
          <div>
            <h4 className="mb-4">Service Area</h4>
            <div className="flex items-start gap-2 text-sm text-muted-foreground">
              <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <div>
                <p>Manhattan, Brooklyn, Queens,</p>
                <p>Bronx, Staten Island</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>© {currentYear} NY Glass. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
